import Title from "@components/common/Title";
import useIcons from "@hooks/use-source-icons";
import { StepsDynamicZoneModel } from "@models/strapi-components/steps";
import { hexToRGB } from "@utils/common";
import React from "react";

export interface StepsComponentProps {
  componentData: StepsDynamicZoneModel;
}
const Steps: React.FunctionComponent<StepsComponentProps> = ({
  componentData,
}) => {
  const { title, tiles, bgColor, stepText } = componentData;
  const { getFromReactIcons } = useIcons();
  return (
    <div
      className=" flex flex-col items-center py-12 md:py-[60px] xl:py-20 px-4"
      style={{ backgroundColor: bgColor ?? "#FFFFFF" }}
    >
      <Title
        variant="h2"
        titleText={title}
        className="text-center mb-8 xl:mb-8 max-w-[70%] mx-auto"
      />
      <div className="max-w-[1021px] bg-white rounded-2xl shadow md:flex p-5 md:p-[70px] relative mt-8 md:mt-0 justify-center">
        <div className="steps-horizontal-line">&nbsp;</div>
        {tiles.map((tile, idx) => {
          const { id, color, icon, title, subTitle } = tile;
          const Icon = getFromReactIcons(icon);
          return (
            <div
              className="flex flex-col items-center my-8 md:my-0 md:mx-2 last:mr-2.5 max-w-[350px] md:max-w-none"
              key={id}
            >
              <div className="flex flex-col items-center mb-9">
                <div
                  className="w-[80px] h-[25px] px-3 rounded-[50px] justify-center items-center gap-2.5 inline-flex mb-2"
                  style={{ backgroundColor: hexToRGB(color ?? "#FFFFFF", 0.1) }}
                >
                  <div className="text-center text-zinc-800 text-xs font-light leading-loose">
                    {stepText} {idx + 1}
                  </div>
                </div>
                <div className="w-[22px] h-[22px] relative z-20">
                  <div
                    className="w-[22px] h-[22px] left-0 top-0 absolute rounded-full border z-20"
                    style={{
                      borderColor: color,
                    }}
                  />
                  <div
                    className="w-3 h-3 left-[5px] top-[5px] absolute rounded-full z-20"
                    style={{ backgroundColor: color }}
                  />
                  <div className="steps-vertical" />
                </div>
              </div>
              <div
                style={{ backgroundColor: hexToRGB(color ?? "#FFFFFF", 0.1) }}
                className="p-6 lg:p-10 rounded-lg h-full flex flex-col items-center justify-start md:block "
              >
                <div className="flex justify-center mb-4 opacity-100">
                  {Icon && <Icon size={32} />}
                </div>
                <Title
                  variant="h3"
                  titleText={title}
                  className="text-center !opacity-100"
                />
                <Title
                  variant="paragraph"
                  titleText={subTitle}
                  className="text-center"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Steps;
